// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as StaticImage from "../../../StaticImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.marginBottom(BsCss.px(50)),
      tl: {
        hd: BsCss.media("(max-width: 768px)", {
              hd: BsCss.marginBottom(BsCss.px(24)),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var valueIcon = Curry._1(BsCss.style, {
      hd: BsCss.display("block"),
      tl: {
        hd: BsCss.width(BsCss.px(50)),
        tl: {
          hd: BsCss.height(BsCss.px(50)),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(12)),
            tl: /* [] */0
          }
        }
      }
    });

var brandText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(22)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(28)),
        tl: {
          hd: BsCss.color(Theme.Color.prezzeeRed),
          tl: {
            hd: BsCss.fontWeight("light"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: {
                hd: BsCss.display("inlineBlock"),
                tl: {
                  hd: BsCss.paddingRight(BsCss.px(5)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var titleText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(22)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(28)),
        tl: {
          hd: BsCss.color(Theme.Color.charcoal),
          tl: {
            hd: BsCss.fontWeight("semiBold"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: {
                hd: BsCss.display("inlineBlock"),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var bodyText = Curry._1(BsCss.style, {
      hd: Theme.Typography.defaultFonts,
      tl: {
        hd: BsCss.fontSize(BsCss.px(16)),
        tl: {
          hd: BsCss.lineHeight(BsCss.px(25)),
          tl: {
            hd: BsCss.color(Theme.Color.midGrey),
            tl: {
              hd: BsCss.fontWeight("normal"),
              tl: {
                hd: BsCss.fontStyle("normal"),
                tl: {
                  hd: BsCss.paddingTop(BsCss.px(10)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  valueIcon: valueIcon,
  brandText: brandText,
  titleText: titleText,
  bodyText: bodyText
};

function ValueElement(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(StaticImage.make, {
                            src: props.valueIconUrl,
                            alt: "value icon",
                            width: 50,
                            height: 50
                          }),
                      className: valueIcon
                    }),
                JsxRuntime.jsx("div", {
                      children: props.brandText,
                      className: brandText
                    }),
                JsxRuntime.jsx("div", {
                      children: props.titleText,
                      className: titleText
                    }),
                JsxRuntime.jsx("div", {
                      children: props.bodyText,
                      className: bodyText
                    })
              ],
              className: container
            });
}

var Img;

var make = ValueElement;

export {
  Img ,
  Styles ,
  make ,
}
/* container Not a pure module */
